import React, { Suspense, lazy } from 'react'

const ScoutFeatureMapInner = lazy(() => import('./scoutFeatureMap'))

export default function ScoutFeatureMap(props) {
    return (
        <Suspense fallback={null}>
            <ScoutFeatureMapInner {...props} />
        </Suspense>
    )
}
